import React, { memo } from "react";
import { Handle } from "react-flow-renderer";
import { useNodeStorage } from "../../../stores/useNodeStorage";

const TrashIcon = () => (
  <svg width="11" height="11" viewBox="0 0 24 24" fill="currentColor">
    <path d="M9 3V4H4V6H5V20C5 21.1 5.9 22 7 22H17C18.1 22 19 21.1 19 20V6H20V4H15V3H9ZM7 6H17V20H7V6ZM9 8V18H11V8H9ZM13 8V18H15V8H13Z"/>
  </svg>
);

export default memo(({ data, isConnectable, id }) => {
  const storageItems = useNodeStorage();

  return (
    <div style={{
      background: "#ffffff",
      borderRadius: 16,
      border: "1px solid rgba(239, 68, 68, 0.15)",
      boxShadow: "0 4px 16px rgba(239, 68, 68, 0.08), 0 1px 4px rgba(0,0,0,0.04)",
      width: 100,
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      padding: "14px 14px 12px",
      fontFamily: "Inter, ui-sans-serif, system-ui, sans-serif",
      position: "relative",
      cursor: "default",
    }}>
      {/* Input handle */}
      <Handle
        type="target"
        position="left"
        className="node-handle-in"
        style={{ left: -7, top: "50%", background: "#ef4444" }}
        isConnectable={isConnectable}
      />

      {/* Delete button */}
      <button
        style={{
          position: "absolute",
          top: 6, right: 6,
          width: 20, height: 20,
          borderRadius: "50%",
          background: "rgba(239, 68, 68, 0.10)",
          border: "none",
          display: "flex", alignItems: "center", justifyContent: "center",
          cursor: "pointer", color: "#ef4444",
          padding: 0,
        }}
        title="Excluir"
        onClick={() => { storageItems.setNodesStorage(id); storageItems.setAct("delete"); }}
        onMouseEnter={e => { e.currentTarget.style.background = "#fecdd3"; }}
        onMouseLeave={e => { e.currentTarget.style.background = "rgba(239,68,68,0.10)"; }}
      >
        <TrashIcon />
      </button>

      {/* Big icon */}
      <div style={{
        width: 48,
        height: 48,
        borderRadius: "50%",
        background: "linear-gradient(135deg, #ef4444 0%, #dc2626 100%)",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        marginBottom: 8,
        boxShadow: "0 6px 16px rgba(239, 68, 68, 0.30)",
      }}>
        <svg width="22" height="22" viewBox="0 0 24 24" fill="white">
          <path d="M10.09 15.59L11.5 17l5-5-5-5-1.41 1.41L12.67 11H3v2h9.67l-2.58 2.59zM19 3H5c-1.11 0-2 .9-2 2v4h2V5h14v14H5v-4H3v4c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2z"/>
        </svg>
      </div>

      {/* Label */}
      <span style={{
        fontSize: 13,
        fontWeight: 700,
        color: "#be123c",
        letterSpacing: "-0.01em",
      }}>
        Sair
      </span>
    </div>
  );
});
